const CONSENT_KEY = 'cookie-consent'

export function getCookieConsent() {
  if (typeof window === 'undefined') return null

  const value = localStorage.getItem(CONSENT_KEY)
  if (value === 'accepted' || value === 'rejected') return value
  return null
}

export function setCookieConsent(accepted) {
  localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'rejected')
}
